import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default, { forwardRef, useRef, useState } from 'react';
import classNames from 'classnames';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import { Alignments } from './a06c6f76e084627ad63dad72cb6669a0a8dc74141d25c552099ec88774dc0199.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import useComputedWidth from './3e62b007b8a431629c15dd67376756dec11a706834ec7f4e7b63f14fd471f544.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["value", "setValue", "renderCellContent", "isCellContentInteractive", "width", "widthBuffer", "alignment", "rowId", "columnId", "rowIndex", "columnIndex", "data-testid", "isFocused", "onKeyDown", "onFocus", "isDragging", "isFinalNonRowActionsColumn", "className"];
var AdvancedTableCell = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var value = _ref.value,
    setValue = _ref.setValue,
    renderCellContent = _ref.renderCellContent,
    _ref$isCellContentInt = _ref.isCellContentInteractive,
    isCellContentInteractive = _ref$isCellContentInt === void 0 ? true : _ref$isCellContentInt,
    width = _ref.width,
    widthBuffer = _ref.widthBuffer,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? Alignments.Left : _ref$alignment,
    rowId = _ref.rowId,
    columnId = _ref.columnId,
    rowIndex = _ref.rowIndex,
    columnIndex = _ref.columnIndex,
    dataTestId = _ref['data-testid'],
    isFocused = _ref.isFocused,
    onKeyDown = _ref.onKeyDown,
    onFocus = _ref.onFocus,
    isDragging = _ref.isDragging,
    isFinalNonRowActionsColumn = _ref.isFinalNonRowActionsColumn,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var cellRef = useRef(null);
  var focusableElementRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEditing = _useState2[0],
    setIsEditing = _useState2[1];
  var isInteractive = typeof renderCellContent === 'function' && isCellContentInteractive;
  var handleClick = isInteractive ? function (e) {
    if (e.target !== e.currentTarget) {
      e.stopPropagation(); // Prevent click event from causing row selection with interactive cell content
    }
  } : undefined;
  var handleKeyDown = function handleKeyDown(e) {
    if (e.target === e.currentTarget && e.key === 'Enter' && isInteractive) {
      var _focusableElementRef$;
      (_focusableElementRef$ = focusableElementRef.current) === null || _focusableElementRef$ === void 0 || _focusableElementRef$.focus();
      e.preventDefault(); // Prevent click event from occurring on the focusable element
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  var handleFocus = function handleFocus(e) {
    onFocus === null || onFocus === void 0 || onFocus(e);
    if (isInteractive) {
      if (e.target !== e.currentTarget) {
        setIsEditing(true);
      } else {
        setIsEditing(false);
      }
    }
  };
  var handleBlur = isInteractive ? function (e) {
    if (e.target !== e.currentTarget) {
      setIsEditing(false);
    }
  } : undefined;
  var focusCell = function focusCell() {
    var _cellRef$current;
    (_cellRef$current = cellRef.current) === null || _cellRef$current === void 0 || _cellRef$current.focus();
  };
  var computedWidth = useComputedWidth(widthBuffer, width);
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    role: "gridcell",
    "data-testid": dataTestId,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    onBlur: handleBlur,
    tabIndex: isFocused && !isEditing ? 0 : -1,
    className: classNames(className, styles.advancedTableCell, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, styles.leftAligned, alignment === Alignments.Left), styles.centerAligned, alignment === Alignments.Center), styles.rightAligned, alignment === Alignments.Right), styles.isDragging, isDragging), styles.fillRemainingSpace, isFinalNonRowActionsColumn && width === undefined)),
    style: {
      width: computedWidth
    },
    ref: mergeRefs(ref, cellRef)
  }), /*#__PURE__*/React__default.createElement("div", {
    className: styles.advancedTableCellContainer
  }, /*#__PURE__*/React__default.createElement("span", null, typeof renderCellContent === 'function' ? renderCellContent({
    value: value,
    setValue: setValue,
    focusCell: focusCell,
    focusableElementRef: focusableElementRef,
    isEditing: isEditing,
    rowId: rowId,
    columnId: columnId,
    rowIndex: rowIndex,
    columnIndex: columnIndex
  }) : value)));
});

export { AdvancedTableCell as default };
